import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'apple-wallet-badge',
  styleUrl: 'apple-wallet-badge.css',
})
export class AppleWalletBadge {
  @Prop() widthPx: number = 125;
  @Prop() heightPx: number = 35;
  @Prop() onClickHandler: () => void = () => {};

  render() {
    return (
      <Host>
        <div class="cursor-pointer" style={{ width: `${this.widthPx}px`, height: `${this.heightPx}px` }}>
          <svg-icon datatest-id="apple-wallet-badge" icon="apple-wallet-badge" onClick={() => this.onClickHandler()} />
        </div>
      </Host>
    );
  }
}
